import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ title, subtitle }) {
  return (
    <>
      {/* Breadcrumb */}
      <nav className="flex items-center text-xs md:text-sm text-slate-500 mb-0.5">
        <Link to="/" className="hover:text-blue-600 transition font-medium">
          Home
        </Link>

        <ChevronRight className="w-3 h-3 mx-1.5 text-slate-400" />

        <span className="text-slate-700 font-medium truncate">
          {title}
        </span>
      </nav>

      {/* Title */}
      <h1 className="text-lg md:text-xl lg:text-2xl font-semibold text-slate-900 leading-snug">
        {title}
      </h1>

      {/* Subtitle */}
      {subtitle && (
        <p className="mt-0.5 text-xs md:text-sm text-slate-600 max-w-3xl">
          {subtitle}
        </p>
      )}
    </>
  );
}
